import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCaravanasStock = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'grafico_stock_caravanas',
        name: 'Grafico Stock Caravanas',
        component: ViewCaravanasStock,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router